import { Component, OnInit } from '@angular/core';
import { User } from '../../models/user';
import { UserService } from '../../services/user.service';
import * as fa from '@fortawesome/free-solid-svg-icons';
import { faCircleNotch, faCoffee } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'wsb-styleguide',
  templateUrl: './styleguide.component.html',
  styleUrls: ['./styleguide.component.scss'],
  standalone: false
})
export class StyleguideComponent implements OnInit {
  title = 'frontend';
  buttonloading = false;
  openMyModal = false;
  user: User | null;
  fa = fa;
  faCircleNotchIcon = faCircleNotch;
  faCoffeeIcon = faCoffee;

  randomWithBreak = this.randomString(true);

  constructor(private userService: UserService) {}

  ngOnInit(): void {
    this.userService.getAuthenticationState().subscribe(next => (this.user = next));
  }

  doSomething(a: any): void {
    // console.log('Main component action' + a);
  }
  spinMe(): void {
    this.buttonloading = true;
    setTimeout(() => (this.buttonloading = false), 1000, this);
  }

  doModal(): void {
    this.openMyModal = true;
  }

  randomString(lineBreak: boolean): string {
    let randomString = Math.random()
      .toString(36)
      .substring(2, 15);
    if (lineBreak) {
      randomString = randomString + '\n';
    }
    randomString =
      randomString +
      Math.random()
        .toString(36)
        .substring(2, 15);
    return randomString;
  }
}
